// AUTO-GENERATED by scripts/gen-version.js on each build — do not edit (gitignored).
export const BUILD_INFO = {
  version: "0.1.0+50",
  semver: "0.1.0",
  build: "50",
  commit: "f1db2b0",
  branch: "dev",
  builtAt: "2026-11-03T23:58:50.523Z",
  codename: "homie",
};

export type BuildInfo = typeof BUILD_INFO;
